import {
  getErc20Error,
  getMessageFromErrorParser,
  getProxyErrorCode,
  getSwaapErrorCode,
} from './error-parser'
import { ERROR_LIST, PROXY_ERROR_LIST } from './swaap-error-list'

const UNEXPECTED_ERROR = 'Transaction cancelled'
const SEND_GENERIC_ERROR = true

export function extractErrorMessage(error: any) {
  if (error === undefined || error === '') {
    return UNEXPECTED_ERROR
  }

  try {
    const errorCode = error.code
    if (errorCode) {
      const message = getMessageFromWalletCode(errorCode)
      if (message) {
        return message
      }
    }
    const reason = errorToStringReason(error)

    // swaap errors from pool
    const swaapErrorCode = getSwaapErrorCode(reason)
    if (swaapErrorCode) {
      return getMessageFromSwaapCode(swaapErrorCode)
    }

    const proxyErrorCode = getProxyErrorCode(reason)
    if (proxyErrorCode) {
      return getMessageFromProxyCode(proxyErrorCode)
    }

    // errors from metamask
    if (reason.toLowerCase().includes('within 50 blocks')) {
      return 'Your transaction is still pending. \n Consider increasing the gas price using your wallet to speed it up.'
    }

    if (SEND_GENERIC_ERROR) {
      return UNEXPECTED_ERROR
    }

    const genericMessage = getMessageFromErrorParser(reason)

    // erc20 error
    const erc20Error = getErc20Error(genericMessage)
    if (erc20Error) {
      return erc20Error
    }

    const res = minimizeErrorSize(genericMessage)
    return res
  } catch (e) {
    return UNEXPECTED_ERROR
  }
}

function errorToStringReason(error: any): string {
  let reason: string = error

  if (
    typeof error === 'object' ||
    error.message ||
    error.data ||
    error.error ||
    error.reason
  ) {
    while (Boolean(error)) {
      reason = error.reason ?? error.message ?? reason
      error = error.error ?? error.data?.originalError
    }
  }

  return reason
}

interface HasSubstate {
  subState: any
}

/**
 * @deprecated: use directly extractErrorMessage
 */
export function extractErrorFromState(state: HasSubstate) {
  if (state.subState) {
    const subState = state.subState
    if (subState.error && subState.message) {
      // error should be boolean
      return extractErrorMessage(subState.message)
    } else if (subState.error) {
      // @deprecated TODO : track and remove where error could be a string
      return extractErrorMessage(subState.error)
    } else {
      return extractErrorMessage(subState)
    }
  }

  return UNEXPECTED_ERROR
}

function getMessageFromWalletCode(stringCode: string): string | undefined {
  let code = Number(stringCode)
  if (isNaN(code)) {
    return undefined
  }

  switch (code) {
    case 4001:
      return 'User rejected transaction'
    case -32603:
      return 'Transaction rejected: gas price too low.\n Consider increasing the gas price.'
  }

  return UNEXPECTED_ERROR
}

function getMessageFromSwaapCode(swaapCode: number): string {
  return ERROR_LIST[swaapCode] || UNEXPECTED_ERROR
}

function getMessageFromProxyCode(proxyCode: number): string {
  return PROXY_ERROR_LIST[proxyCode] || UNEXPECTED_ERROR
}

export function minimizeErrorSize(errorMessage: string, maxSize = 40) {
  if (errorMessage.length > maxSize) {
    return errorMessage.slice(0, 27) + '...'
  } else {
    return errorMessage
  }
}

/**
 * This function currently does nothing but may later send anonymized data
 * to an external logger
 * @param reason
 * @param component
 */
export function sendIllegalStateException(reason: string, component: any) {
  console.warn('illegal state:', reason, component.toString())
}
